<template>
  <div>
     <transition name="fade">
      <div v-show="show" id="canva-cta-popup" class="white-popup rounded-lg shadow text-center">
        <i class="fas fa-check-circle fa-2x text-success pt-3"></i>
        <h5 class="mb-4 mt-2">You've got your image.<br>Now use it in Canva!</h5>
        <div class="d-flex justify-content-center mb-4">
          <div class="image-wrapper image-wrapper-1 d-flex align-items-end justify-content-end rounded flex-shrink-0 pl-1 mr-2" style="background-image: url('/images/canva-cta/bg_post_1.jpg')">
            <img :src="image" class="img-fluid" />
          </div>
          <div class="image-wrapper image-wrapper-2 d-flex align-items-end justify-content-end rounded flex-shrink-0 pl-1 mr-2" style="background-image: url('/images/canva-cta/bg_post_2.jpg')">
            <img :src="image" class="img-fluid" />
          </div>
          <div class="image-wrapper image-wrapper-3 d-flex align-items-end justify-content-end rounded flex-shrink-0 pl-1 mr-2" style="background-image: url('/images/canva-cta/bg_post_3.jpg')">
            <img :src="image" class="img-fluid" />
          </div>
        </div>
        <p class="text-muted mx-auto w-75 small">Turn it into a post, document, presentation, anything.</p>
        <div class="d-flex mt-4 pb-2 align-items-center justify-content-between">
          <button class="btn btn-link" @click.prevent="close(true)">Maybe later</button>
          <a :href="url" @click="report" target="_blank" rel="noopener noreferer" class="btn btn-primary text-white">Use it in Canva</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EventBus from "../src/event_bus"
import Cookie from "../src/cookie.js"

export default {
  props: {
    image: String,
    variant: String,
  },

  data() {
    return {
      conversion: false,
      isOpen: false,
      openDelay: 2500,
      cookieMaxAge: 30, // days
      cookieName: "post_download_cta_experiment",
      showPreference: "show",
    }
  },

  mounted() {
    EventBus.$on("preview-download-started", () => {
      setTimeout(() => {
         this.open()
      }, this.openDelay);
    })

    EventBus.$on("updated-show-preferences", () => {
      this.loadShowPreference()
    })

    this.loadShowPreference()
  },

  methods: {
    loadShowPreference() {
       $.ajax({
        type: "GET",
        url: "/session_preferences/get?key=canva_post_cta_experiment&default=show",
        success: (data) => {
          this.showPreference = data.value
        }
      })
    },

    saveShowPreference(value) {
      this.showPreference = value


      $.ajax({
        type: "POST",
        url: "/session_preferences/set",
        data: {
          key: "canva_post_cta_experiment",
          value: value
        },
        success: () => {
          EventBus.$emit("updated-show-preferences")
        }
      })


    },

    open() {
      if(this.cookieExists) return
      if(this.showPreference == "dismiss") return

      const self = this;

      $.magnificPopup.open({
        items: {
          src: "#canva-cta-popup"
        },
        type: "inline",
        callbacks: {
          open: function() {
            self.conversion = false
            self.isOpen = true
          },

          close: function() {
            this.isOpen = false
            if(!self.conversion) {
              self.saveShowPreference("dismiss")
              self.setCookie()
            }
          }
        }
      })
      this.isOpen = true
    },

    close() {
      $.magnificPopup.close()
      this.isOpen = false

      if(!this.conversion) {
        this.saveShowPreference("dismiss")
        this.setCookie()
      }
    },

    report() {
      this.conversion = true
      reportSplit("canva_cta_conversion", null, false)
      this.close()
    },

    setCookie() {
      Cookie.set(this.cookieName, "functional", "dismiss", { expires: this.cookieMaxAge });
    }
  },

  computed: {
    url() {
      const campaign = `en_all_canva_acq_conversion_kaleido_variant_postDownload`
      const url = new URL("https://canva.com")

      url.searchParams.append("utm_medium", "referral")
      url.searchParams.append("utm_source", "removebg")
      url.searchParams.append("utm_campaign", campaign)

      return url.href
    },

    show() {
      if(this.cookieExists) return false
      if(this.showPreference == "dismiss") return false

      return this.isOpen
    },

    cookieExists() {
     return Cookie.get(this.cookieName)  == "dismiss"
    }
   },
}
</script>

<style lang="scss" scoped>

#canva-cta-popup {
  max-width: 330px;
}

.image-wrapper {
  overflow: hidden;
  width: 72px;
  height: 72px;
  background-position: center;
  background-size: cover;

  img {
    max-height: 72px;
    display: block;
    object-fit: contain;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
